import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CreateNotaDto, UpdateNotaDto } from '../models/nota.model';

@Injectable({
  providedIn: 'root',
})
export class NotaService {
  private readonly path = 'bolsa';

  constructor(private apiService: ApiService) {}

  list(params?: any): Observable<any> {
    return this.apiService
      .get<any>(
        `${this.path}/Notas`,
        params ? new HttpParams({ fromObject: params }) : new HttpParams()
      )
      .pipe(map((response) => response));
  }

  create(payload: CreateNotaDto): Observable<any> {
    return this.apiService
      .post<any>(`${this.path}/Notas`, payload)
      .pipe(map((response) => response));
  }

  update(payload: UpdateNotaDto): Observable<any> {
    return this.apiService
      .put<any>(`${this.path}/Notas`, payload)
      .pipe(map((response) => response));
  }
}
